import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import WorkCarousel from '../WorkCarousel/WorkCarousel'
import { useServiceData } from '../../hooks/useServiceData'

const WorkServiceBlock = () => {
  const { slug } = useParams()
  const { data: service, isLoading } = useServiceData(slug)

  const items = useMemo(() => {
    const pairs = service?.beforeAfter
    if (!pairs || pairs.length === 0) return []
    const title = service?.title || 'автомобиля'
    return [...pairs]
      .sort((a, b) => a.order - b.order)
      .map((pair, i) => ({
        id: `work-service-${i}`,
        beforeSrc: pair.beforeImage,
        afterSrc: pair.afterImage,
        altBefore: `До — ${title}`,
        altAfter: `После — ${title}`,
      }))
  }, [service])

  return (
    <WorkCarousel
      title="Работы до и после"
      items={items}
      isLoading={isLoading}
      footerDescription="Короткая визуальная демонстрация результата до и после работ."
    />
  )
}

export default WorkServiceBlock
